// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import HotkeysSettingsContainerTemplate from '@front/templates/HotkeysSettingsContainerTemplate.html';
import { HotkeysManager } from '@shared/commons/cache/Hotkeys/HotkeysManager';
import { HotkeysGroupTrading } from '@shared/commons/cache/Hotkeys/NamesEventHotkey ';
import { Resources } from '@shared/localizations/Resources';
import { CustomEvent } from '@shared/utils/CustomEvents';
import { HotkeysEditControlEvents } from './HotkeysEditControl';
import { PanelNames } from '../../UtilsClasses/FactoryConstants';
import { Control } from '../Control';
export class HotkeysSettingsContainer extends Control {
    constructor() {
        super(...arguments);
        this.HotkeyValueChanged = new CustomEvent();
    }
    oninit() {
        super.oninit();
        void this.set({
            groupItems: this.createGroupItems()
        });
    }
    oncomplete() {
        super.oncomplete();
        this.on(HotkeysEditControlEvents.ValueChanged, this.valueChangedEvent);
    }
    createGroupItems() {
        var _a;
        const map = HotkeysManager.GetHotkeysMap();
        const groupItems = [];
        for (const key of map.keys()) {
            groupItems.push(new HotkeyGroup(this.getNameGroup(key), (_a = map.get(key)) !== null && _a !== void 0 ? _a : []));
        }
        return groupItems;
    }
    getNameGroup(key) {
        switch (key) {
            case PanelNames.ChartPanel:
                return Resources.getResource('panel.chart');
            case PanelNames.MarketDepthPanel:
                return Resources.getResource('panel.level2');
            case PanelNames.AdvancedOrderEntry:
                return Resources.getResource('panel.orderEntry');
            case HotkeysGroupTrading:
                return Resources.getResource('property.Trading');
            case PanelNames.OrdersPanel:
                return Resources.getResource('panel.orders');
            case PanelNames.InformerPanel:
                return Resources.getResource('panel.informer');
            default:
                return key;
        }
    }
    valueChangedEvent(_context, item, value) {
        this.HotkeyValueChanged.Raise(this, item, value);
    }
}
Control.extendWith(HotkeysSettingsContainer, {
    template: HotkeysSettingsContainerTemplate,
    data: function () {
        return {
            groupItems: []
        };
    }
});
export class HotkeyGroup {
    constructor(groupName, groupItems = []) {
        this.GroupName = groupName;
        this.GroupItems = groupItems;
    }
}
